import Calendar from './Calendar.react';

class DateTime extends React.Component {

    render() {
        const date = this.props.date;
        const time = this.props.time;
        const top  = this.props.top ? this.props.top : 0;
        const left = this.props.left ? this.props.left : 0;

        return (
            <div className='date-time'>
                <Calendar
                    selectDate={(date) => { this.props.selectDate(date); }}
                    allowPastDate={this.props.allowPastDate}
                    date={date}
                    top={top}
                    left={left}
                    className='date-time__calendar'
                />
                <input
                    type='text'
                    className='date-time__time'
                    value={time}
                    onChange={(e) => { this.props.selectTime(e.target.value); }}
                />
            </div>
        );
    }
}

export default DateTime;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/DateTime.react.jsx